// Generated by purs version 0.15.15
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var selectedOptionIsSymbol = {
    reflectSymbol: function () {
        return "selectedOption";
    }
};
var selectedValueIsSymbol = {
    reflectSymbol: function () {
        return "selectedValue";
    }
};
var SetCheckoutOptionIsSymbol = {
    reflectSymbol: function () {
        return "SetCheckoutOption";
    }
};
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var encodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode);
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var decodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode);
var SetCheckoutOption = function (x) {
    return x;
};
var toFillFormTypeSetCheckout = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var newtypeSetCheckoutOption_ = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldSetCheckoutOption = function (dictHasField) {
    return dictHasField;
};
var eqSetCheckoutOption = {
    eq: function (x) {
        return function (y) {
            return x.selectedOption === y.selectedOption && x.selectedValue === y.selectedValue;
        };
    }
};
var genericSetCheckoutOption = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showSetCheckoutOption = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericSetCheckoutOption)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons(selectedOptionIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(selectedValueIsSymbol)(Data_Show.showString))(Data_Show.showString))))(SetCheckoutOptionIsSymbol))
};
var unscrambleDecodeSetCheckoutOption = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericSetCheckoutOption)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons(selectedOptionIsSymbol)(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons(selectedValueIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordNil))))))(Unscramble_Generic.defaultOptions)
};
var encodeSetCheckoutOption = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericSetCheckoutOption)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(SetCheckoutOptionIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil)(selectedValueIsSymbol)(encodeWithOptionsOther))(selectedOptionIsSymbol)(encodeWithOptionsOther)))))
};
var decodeSetCheckoutOption = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericSetCheckoutOption)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(SetCheckoutOptionIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(Foreign_Generic_Class.decodeRecordNil)(selectedValueIsSymbol)(decodeWithOptionsOther)())(selectedOptionIsSymbol)(decodeWithOptionsOther)())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    SetCheckoutOption,
    genericSetCheckoutOption,
    eqSetCheckoutOption,
    showSetCheckoutOption,
    encodeSetCheckoutOption,
    decodeSetCheckoutOption,
    unscrambleDecodeSetCheckoutOption,
    toFillFormTypeSetCheckout,
    hasFieldSetCheckoutOption,
    newtypeSetCheckoutOption_
};
